const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const BlogService = {
  async fetchPosts(page = 1, perPage = 12, categoryId = null) {
    try {
      let url = `${API_BASE_URL}/blog/posts/?page=${page}&per_page=${perPage}`;
      
      if (categoryId) {
        url += `&category=${categoryId}`;
      }
      
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error fetching blog posts:', error);
      throw error;
    }
  },

  async fetchPostBySlug(slug) {
    try {
      const response = await fetch(`${API_BASE_URL}/blog/posts/${slug}/`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error fetching blog post:', error);
      throw error;
    }
  },

  async fetchCategories() {
    try {
      const response = await fetch(`${API_BASE_URL}/blog/categories/`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error fetching blog categories:', error);
      throw error;
    }
  },

  async searchPosts(query) {
    try {
      const response = await fetch(`${API_BASE_URL}/blog/search/?q=${encodeURIComponent(query)}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error searching blog posts:', error);
      throw error;
    }
  },

  async trackVisit(slug) {
    try {
      const response = await fetch(`${API_BASE_URL}/blog/posts/${slug}/track-visit/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error tracking visit:', error);
      throw error;
    }
  },
};

export default BlogService; 